(ns frontend.view.nev.kyc.process.tax-country-editor
  (:require
   [clojure.data :as data]
   [common.country :as country]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [frontend.view.modals.events :as modals]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.editors.labelled-input.view :as labelled-input]
   [frontend.tenant-customizations :as tenant-customizations]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]
   [common.schema.entities.workspace.kyc.kyc-utils :as kyc-utils]))

(defn add-tax-country!
  [{:keys [lang-kw answers-atom q tax-countries save! _localized-options _value]}]
  (let [tax-ratom (r/atom {})
        calc-new-tax-countries (fn []
                                 (concat tax-countries
                                         [{:ord                (count tax-countries)
                                           :country            (:country @tax-ratom)
                                           :tin-missing-reason (:tin-missing-reason @tax-ratom)
                                           :tin                (:tin @tax-ratom)}]))
        options (->> (country/localized-options lang-kw)
                     (mapv (fn [opt]
                             {:value (:keyword opt)
                              :label (:label opt)})))]
    (modals/open-modal!
     dynamic-modal/modal-key
     {:title               (loc/tr :add-tax-country nil lang-kw)
      :render-fn           (fn [modal-state _close-modal!]
                             [:div
                              {:class "p-3 flex flex-col gap-4"}
                              [labelled-input/view
                               {:label       (loc/tr :tax-country nil lang-kw)
                                :editor-type :editor.type/select
                                :value       (->> options
                                                  (cu/filter-by :value (:country @tax-ratom))
                                                  (first))
                                :options     options
                                :on-change   (fn [selected-value _selected-option]
                                               (swap! tax-ratom assoc
                                                      :country
                                                      selected-value)
                                               (swap! modal-state assoc
                                                      :value
                                                      (and selected-value
                                                           (or (= :FI selected-value)
                                                               (not-empty (:tin @tax-ratom))
                                                               (not-empty (:tin-missing-reason @tax-ratom))))))}]
                              (when (and (:country @tax-ratom)
                                         (not= :FI (:country @tax-ratom)))
                                [labelled-input/view
                                 {:label     (loc/tr :tax-country-tax-id nil lang-kw)
                                  :data-type :data.type/text-simple
                                  :value     (:tin @tax-ratom)
                                  :on-change (fn [new-value]
                                               (swap! tax-ratom assoc
                                                      :tin
                                                      new-value)
                                               (swap! modal-state assoc
                                                      :value
                                                      (and (or (seq (:tin-missing-reason @tax-ratom))
                                                               (seq (:tin @tax-ratom)))
                                                           (:country @tax-ratom))))
                                  :on-save!  (fn [new-value]
                                               (swap! tax-ratom assoc
                                                      :tin
                                                      new-value)
                                               (swap! modal-state assoc
                                                      :value
                                                      (and (or (seq (:tin-missing-reason @tax-ratom))
                                                               (seq (:tin @tax-ratom)))
                                                           (:country @tax-ratom))))}])
                              (when (and (:country @tax-ratom)
                                         (not= :FI (:country @tax-ratom)))
                                [labelled-input/view
                                 {:data-type :data.type/text-simple
                                  :value     (:tin-missing-reason @tax-ratom)
                                  :label     (loc/tr :tax-country-tax-id-missing nil lang-kw)
                                  :on-save!  (fn [new-value]
                                               (swap! tax-ratom assoc
                                                      :tin-missing-reason
                                                      new-value)
                                               (swap! modal-state assoc
                                                      :value
                                                      (and (or (seq (:tin-missing-reason @tax-ratom))
                                                               (seq (:tin @tax-ratom)))
                                                           (:country @tax-ratom))))
                                  :validate! (fn [temp-value]
                                               (swap! modal-state assoc
                                                      :value
                                                      (and (or (seq (:tin @tax-ratom))
                                                               (seq temp-value))
                                                           (:country @tax-ratom)))
                                               false)
                                  :on-change (fn [new-value]
                                               (swap! tax-ratom assoc
                                                      :tin-missing-reason
                                                      new-value)
                                               (swap! modal-state assoc
                                                      :value
                                                      (and (or (seq (:tin-missing-reason @tax-ratom))
                                                               (seq (:tin @tax-ratom)))
                                                           (:country @tax-ratom))))}])])
      :show-button?        true
      :button-text         (loc/tr :add-tax-country nil lang-kw)
      :custom-validator-fn (fn [_state]
                             (let [[old-only new-only _common] (data/diff (get q @answers-atom) @tax-ratom)
                                   changes? (or (seq old-only)
                                                (seq new-only))
                                   missing-mandatory-fields (cond (not (:country @tax-ratom))
                                                                  [(loc/tr :country nil lang-kw)]
                                                                  (and (not= :FI (:country @tax-ratom))
                                                                       (empty? (:tin-missing-reason @tax-ratom))
                                                                       (empty? (:tin @tax-ratom)))
                                                                  [(loc/tr :add-tin-or-missing-reason nil lang-kw)])]
                               (or (seq missing-mandatory-fields)
                                   (when (not changes?)
                                     (loc/tr :no-changes)))))

      :on-submit!          (fn [_]
                             (let [new-tax-countries (calc-new-tax-countries)]
                               (swap! answers-atom assoc q new-tax-countries))
                             (save!))
      :on-before-close!    (fn [close!]
                             (if (= (get @answers-atom q) (calc-new-tax-countries))
                               (close!)
                               (modals/open-modal!
                                confirmation-modal/modal-key
                                {:body           (loc/tr :confirm-close-kyc-modal-without-saving nil lang-kw)
                                 :confirm-text   (loc/tr :close-without-saving nil lang-kw)
                                 :confirm-icon   ""
                                 :skip-checkbox? true
                                 :on-confirm     close!})))})))

(defn default-view
  [{:keys [_kyc-entity-editor _process-id _state-atom lang-kw question-attribute _question-meta answers-atom mandatory? read-only? save!]
    :as   _args}]
  (let [tax-countries (->> (get @answers-atom question-attribute)
                           (sort-by :ord))
        hide-tax-number-column? (->> tax-countries
                                     (remove (fn [tc]
                                               (= :FI (:country tc))))
                                     (empty?))]
    [:table.zap-table.zap-table--striped.zap-table--has-footer.zap-table--width-auto
     [:thead.zap-table__headline
      [:tr.zap-table__row
       [:th.zap-table__headline
        {:class
         (when mandatory?
           "after:ml-0.5 after:text-danger-regular after:content-['*']")}
        (loc/tr :tax-country nil lang-kw)]
       (when-not hide-tax-number-column?
         [:<>
          [:th.zap-table__headline
           (loc/tr :tax-country-tax-id-short nil lang-kw)]
          [:th.zap-table__headline
           (loc/tr :tax-country-tax-id-missing-short nil lang-kw)]])
       [:th.zap-table__headline]]]
     [:tbody
      (->> tax-countries
           (map-indexed
            (fn [idx tax-country]
              [:tr.zap-table__row
               {:key (str "tax-country-" idx)}
               [:td.zap-table__cell
                [:span
                 (country/get-label (:country tax-country) lang-kw)]]
               (when-not hide-tax-number-column?
                 [:<>
                  [:td.zap-table__cell
                   [:span
                    (:tin tax-country)]]
                  [:td.zap-table__cell
                   [:span
                    (:tin-missing-reason tax-country)]]])
               [:td.zap-table__cell
                (when-not read-only?
                  [:i.fal.fa-trash-alt.pointer
                   {:on-click (fn [_]
                                (swap! answers-atom assoc
                                       question-attribute
                                       (concat (take idx tax-countries)
                                               (drop (inc idx) tax-countries)))
                                (save!))}])]]))
           (doall))]
     (when-not read-only?
       [:tfoot
        [:tr.zap-table__row
         [:td.zap-table__footer-cell
          {:col-span (if hide-tax-number-column? "2" "4")}
          [button/primary-solid
           {:on-click #(add-tax-country! {:lang-kw       lang-kw
                                          :answers-atom  answers-atom
                                          :q             question-attribute
                                          :tax-countries tax-countries
                                          :save!         save!})}
           [:i.fal.fa-plus.pr-2]
           (loc/tr :add-tax-country nil lang-kw)]]]])]))

(defn capman-add-tax-country!
  [{:keys [lang-kw answers-atom q tax-countries save! _localized-options _value]}]
  (let [tax-ratom (r/atom {})
        calc-new-tax-countries (fn []
                                 (concat tax-countries
                                         [{:ord        (count tax-countries)
                                           :country    (:country @tax-ratom)
                                           :tin-status (:tin-status @tax-ratom)
                                           :tin        (:tin @tax-ratom)}]))
        country-options (->> (country/localized-options lang-kw)
                             (mapv (fn [opt]
                                     {:value (:keyword opt)
                                      :label (:label opt)})))
        tin-status-options (->> kyc-options/capman-tax-country-tin-status-options
                                (mapv (fn [opt]
                                        {:value (:key opt)
                                         :label (get-in opt [:translations lang-kw])})))]
    (modals/open-modal!
     dynamic-modal/modal-key
     {:title               (loc/tr :add-tax-country nil lang-kw)
      :render-fn
      (fn [_modal-state _close-modal!]
        [:div
         {:class "p-3 flex flex-col gap-4"}
         [labelled-input/view
          {:label       (loc/tr :tax-country nil lang-kw)
           :editor-type :editor.type/select
           :value       (->> country-options
                             (cu/filter-by :value (:country @tax-ratom))
                             (first))
           :options     country-options
           :on-change   (fn [selected-value _selected-option]
                          (swap! tax-ratom assoc
                                 :country
                                 selected-value))}]

         (when (and (:country @tax-ratom)
                    (not= :FI (:country @tax-ratom)))
           [labelled-input/view
            {:data-type :data.type/keyword
             :label (loc/tr :do-you-have-tax-identification-number-for-this-country? nil lang-kw)
             :options tin-status-options
             :value (:tin-status @tax-ratom)
             :on-change (fn [value]
                          (swap! tax-ratom assoc :tin-status value))}])

         (when (and (:country @tax-ratom)
                    (not= :FI (:country @tax-ratom))
                    (-> @tax-ratom
                        :tin-status
                        (= :yes-i-have-tin)))
           [labelled-input/view
            {:label     (loc/tr :tax-country-tax-id nil lang-kw)
             :data-type :data.type/text-simple
             :value     (:tin @tax-ratom)
             :on-change (fn [new-value]
                          (swap! tax-ratom assoc
                                 :tin
                                 new-value))
             :on-save!  (fn [new-value]
                          (swap! tax-ratom assoc
                                 :tin
                                 new-value))}])])
      :show-button?        true
      :button-text         (loc/tr :add-tax-country nil lang-kw)
      :custom-validator-fn (fn [_state]
                             (let [[old-only new-only _common] (data/diff (get q @answers-atom) @tax-ratom)
                                   changes? (or (seq old-only)
                                                (seq new-only))
                                   missing-mandatory-fields (cond (not (:country @tax-ratom))
                                                                  [(loc/tr :country nil lang-kw)]

                                                                  (= :FI (:country @tax-ratom))
                                                                  nil

                                                                  (not (:tin-status @tax-ratom))
                                                                  [(loc/tr :do-you-have-tax-identification-number-for-this-country? nil lang-kw)]

                                                                  (and (-> @tax-ratom
                                                                           :tin-status
                                                                           (= :yes-i-have-tin))
                                                                       (cu/blank-value? (:tin @tax-ratom)))
                                                                  [(loc/tr :tax-country-tax-id-short nil lang-kw)])]
                               (or (seq missing-mandatory-fields)
                                   (when (not changes?)
                                     (loc/tr :no-changes)))))

      :on-submit!          (fn [_]
                             (let [new-tax-countries (calc-new-tax-countries)]
                               (swap! answers-atom assoc q new-tax-countries))
                             (save!))
      :on-before-close!    (fn [close!]
                             (if (= (get @answers-atom q) (calc-new-tax-countries))
                               (close!)
                               (modals/open-modal!
                                confirmation-modal/modal-key
                                {:body           (loc/tr :confirm-close-kyc-modal-without-saving nil lang-kw)
                                 :confirm-text   (loc/tr :close-without-saving nil lang-kw)
                                 :confirm-icon   ""
                                 :skip-checkbox? true
                                 :on-confirm     close!})))})))

(defn capman-view
  [{:keys [_kyc-entity-editor _process-id _state-atom lang-kw question-attribute _question-meta answers-atom mandatory? read-only? save!]
    :as   _args}]
  (let [tax-countries (->> (get @answers-atom question-attribute)
                           (sort-by :ord))
        hide-tax-number-column? (->> tax-countries
                                     (remove (fn [tc]
                                               (= :FI (:country tc))))
                                     (empty?))]
    [:table.zap-table.zap-table--striped.zap-table--has-footer.zap-table--width-auto
     {:style {:width "100%"}}
     [:thead.zap-table__headline
      [:tr.zap-table__row
       [:th.zap-table__headline
        {:class
         (when mandatory?
           "after:ml-0.5 after:text-danger-regular after:content-['*']")}
        (loc/tr :tax-country nil lang-kw)]
       (when-not hide-tax-number-column?
         [:<>
          [:th.zap-table__headline
           (loc/tr :tax-country-tax-id-short nil lang-kw)]
          [:th.zap-table__headline
           (loc/tr :tax-country-tax-id-missing-short nil lang-kw)]])
       [:th.zap-table__headline]]]
     [:tbody
      (->> tax-countries
           (map-indexed
            (fn [idx tax-country]
              [:tr.zap-table__row
               {:key (str "tax-country-" idx)}
               [:td.zap-table__cell
                [:span
                 (country/get-label (:country tax-country) lang-kw)]]
               (when-not hide-tax-number-column?
                 [:<>
                  [:td.zap-table__cell
                   [:span
                    (:tin tax-country)]]
                  [:td.zap-table__cell
                   [:span
                    ;; backward compatability
                    (or (:tin-missing-reason tax-country)
                        (when (-> tax-country
                                  :tin-status
                                  (= :country-does-not-issue-tin))
                          (kyc-utils/localize-option
                           {:options kyc-options/capman-tax-country-tin-status-options}
                           []
                           :country-does-not-issue-tin
                           lang-kw)))]]])
               [:td.zap-table__cell
                (when-not read-only?
                  [:i.fal.fa-trash-alt.pointer
                   {:on-click (fn [_]
                                (swap! answers-atom assoc
                                       question-attribute
                                       (concat (take idx tax-countries)
                                               (drop (inc idx) tax-countries)))
                                (save!))}])]]))
           (doall))]
     (when-not read-only?
       [:tfoot
        [:tr.zap-table__row
         [:td.zap-table__footer-cell
          {:col-span (if hide-tax-number-column? "2" "4")}
          [button/primary-solid
           {:on-click #(capman-add-tax-country! {:lang-kw       lang-kw
                                                 :answers-atom  answers-atom
                                                 :q             question-attribute
                                                 :tax-countries tax-countries
                                                 :save!         save!})}
           [:i.fal.fa-plus.pr-2]
           (loc/tr :add-tax-country nil lang-kw)]]]])]))

(defn view
  [args]
  (if (tenant-customizations/capman?)
    [capman-view args]
    [default-view args]))
